import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, Star, AlertTriangle, TrendingUp, TrendingDown, Users, UserPlus, Repeat, Smile } from 'lucide-react';
const CUSTOMER_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Database',
  path: 'database'
}, {
  label: 'Segments',
  path: 'segments'
}, {
  label: 'Reviews',
  path: 'reviews'
}, {
  label: 'Insights',
  path: 'insights'
}];
export function Overview() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-921">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-922">
        <div data-id="element-923">
          <h1 className="text-2xl font-bold text-text-primary flex items-center gap-3" data-id="element-924">
            Customers{' '}
            <span className="text-lg font-normal text-text-secondary" data-id="element-925">
              2,847 total · 312 new this month
            </span>
          </h1>
        </div>
        <div className="flex flex-wrap gap-3 items-center" data-id="element-926">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-927">
            All Locations <ChevronDown size={14} data-id="element-928" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-929">
            Last 30 Days <ChevronDown size={14} data-id="element-930" />
          </button>
          <div className="relative" data-id="element-931">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-932" />
            <input type="text" placeholder="Search..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-48" data-id="element-933" />
          </div>
        </div>
      </div>

      <TabNavigation tabs={CUSTOMER_TABS} basePath="/customers" data-id="element-934" />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-935">
        <Card className="p-4" data-id="element-936">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-937">
            <Users size={16} data-id="element-938" /> Total Customers
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-939">2,847</div>
          <div className="text-xs text-accent-success flex items-center gap-1" data-id="element-940">
            <TrendingUp size={12} data-id="element-941" /> +8% vs LM
          </div>
        </Card>
        <Card className="p-4" data-id="element-942">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-943">
            <UserPlus size={16} data-id="element-944" /> New This Month
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-945">312</div>
          <div className="text-xs text-accent-success flex items-center gap-1" data-id="element-946">
            <TrendingUp size={12} data-id="element-947" /> +15% vs LM
          </div>
        </Card>
        <Card className="p-4" data-id="element-948">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-949">
            <Repeat size={16} data-id="element-950" /> Repeat Rate
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-951">34%</div>
          <div className="text-xs text-accent-success flex items-center gap-1" data-id="element-952">
            <TrendingUp size={12} data-id="element-953" /> +3% vs LM
          </div>
        </Card>
        <Card className="p-4" data-id="element-954">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-955">
            <Smile size={16} data-id="element-956" /> Avg Satisfaction
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-957">9.1 / 10</div>
          <div className="text-xs text-accent-success flex items-center gap-1" data-id="element-958">
            <TrendingUp size={12} data-id="element-959" /> +0.2 vs LM
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-960">
        {/* Customer Breakdown */}
        <Card className="p-6" data-id="element-961">
          <h3 className="font-bold mb-6" data-id="element-962">Customer Breakdown</h3>
          <div className="space-y-4" data-id="element-963">
            <div data-id="element-964">
              <div className="flex justify-between text-sm mb-1" data-id="element-965">
                <span className="text-text-secondary" data-id="element-966">New (1 order)</span>
                <span className="font-bold" data-id="element-967">1,245 (44%)</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-968">
                <div className="h-full bg-blue-500" style={{
                width: '44%'
              }} data-id="element-969"></div>
              </div>
            </div>
            <div data-id="element-970">
              <div className="flex justify-between text-sm mb-1" data-id="element-971">
                <span className="text-text-secondary" data-id="element-972">Returning (2-4)</span>
                <span className="font-bold" data-id="element-973">892 (31%)</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-974">
                <div className="h-full bg-teal-500" style={{
                width: '31%'
              }} data-id="element-975"></div>
              </div>
            </div>
            <div data-id="element-976">
              <div className="flex justify-between text-sm mb-1" data-id="element-977">
                <span className="text-text-secondary" data-id="element-978">Regular (5-10)</span>
                <span className="font-bold" data-id="element-979">489 (17%)</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-980">
                <div className="h-full bg-yellow-500" style={{
                width: '17%'
              }} data-id="element-981"></div>
              </div>
            </div>
            <div data-id="element-982">
              <div className="flex justify-between text-sm mb-1" data-id="element-983">
                <span className="text-text-secondary" data-id="element-984">VIP (11+)</span>
                <span className="font-bold" data-id="element-985">221 (8%)</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-986">
                <div className="h-full bg-accent-primary" style={{
                width: '8%'
              }} data-id="element-987"></div>
              </div>
            </div>
          </div>
        </Card>

        {/* Recent Reviews */}
        <Card className="p-6" data-id="element-988">
          <div className="flex justify-between items-center mb-6" data-id="element-989">
            <h3 className="font-bold" data-id="element-990">Recent Reviews</h3>
            <Button size="sm" variant="secondary" data-id="element-991">
              View All Reviews
            </Button>
          </div>
          <div className="space-y-4" data-id="element-992">
            <div className="p-3 bg-white/5 rounded-lg" data-id="element-993">
              <div className="flex justify-between items-start mb-1" data-id="element-994">
                <div className="flex items-center gap-1 text-accent-success font-bold text-sm" data-id="element-995">
                  <Star size={14} fill="currentColor" data-id="element-996" /> 10
                </div>
                <div className="text-xs text-text-secondary" data-id="element-997">2 hours ago</div>
              </div>
              <p className="text-sm italic mb-2" data-id="element-998">"Najbolji burgeri u gradu!"</p>
              <div className="text-xs text-text-secondary" data-id="element-999">Wolt · Vračar</div>
            </div>
            <div className="p-3 bg-white/5 rounded-lg border border-accent-error/20" data-id="element-1000">
              <div className="flex justify-between items-start mb-1" data-id="element-1001">
                <div className="flex items-center gap-1 text-accent-error font-bold text-sm" data-id="element-1002">
                  <Star size={14} fill="currentColor" data-id="element-1003" /> 6
                </div>
                <div className="flex items-center gap-2" data-id="element-1004">
                  <AlertTriangle size={12} className="text-accent-error" data-id="element-1005" />
                  <div className="text-xs text-text-secondary" data-id="element-1006">5 hours ago</div>
                </div>
              </div>
              <p className="text-sm italic mb-2" data-id="element-1007">"Hrana stigla hladna"</p>
              <div className="text-xs text-text-secondary" data-id="element-1008">Wolt · BB</div>
            </div>
            <div className="p-3 bg-white/5 rounded-lg" data-id="element-1009">
              <div className="flex justify-between items-start mb-1" data-id="element-1010">
                <div className="flex items-center gap-1 text-accent-success font-bold text-sm" data-id="element-1011">
                  <Star size={14} fill="currentColor" data-id="element-1012" /> 9
                </div>
                <div className="text-xs text-text-secondary" data-id="element-1013">Yesterday</div>
              </div>
              <p className="text-sm italic mb-2" data-id="element-1014">"Odlične palačinke"</p>
              <div className="text-xs text-text-secondary" data-id="element-1015">Wolt · NBG</div>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1016">
        {/* Top Customers */}
        <Card className="p-6" data-id="element-1017">
          <h3 className="font-bold mb-4" data-id="element-1018">Top Customers This Month</h3>
          <div className="space-y-3" data-id="element-1019">
            {[{
            name: 'Marko P.',
            orders: 12,
            spent: '28.5K RSD'
          }, {
            name: 'Ana M.',
            orders: 9,
            spent: '21.2K RSD'
          }, {
            name: 'Stefan J.',
            orders: 8,
            spent: '19.8K RSD'
          }].map((customer, i) => <div key={i} className="flex items-center justify-between p-3 bg-white/5 rounded-lg" data-id="element-1020">
                <div className="flex items-center gap-3" data-id="element-1021">
                  <div className="w-8 h-8 rounded-full bg-accent-primary/20 flex items-center justify-center text-sm font-bold text-accent-primary" data-id="element-1022">
                    {i + 1}
                  </div>
                  <span className="font-medium" data-id="element-1023">{customer.name}</span>
                </div>
                <div className="text-right text-sm" data-id="element-1024">
                  <div className="font-bold" data-id="element-1025">{customer.spent}</div>
                  <div className="text-text-secondary" data-id="element-1026">
                    {customer.orders} orders
                  </div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* At Risk */}
        <Card className="p-6 border border-accent-warning/20" data-id="element-1027">
          <div className="flex justify-between items-center mb-4" data-id="element-1028">
            <h3 className="font-bold text-accent-warning flex items-center gap-2" data-id="element-1029">
              <AlertTriangle size={18} data-id="element-1030" /> At Risk (No order 30+ days)
            </h3>
            <Button size="sm" variant="secondary" className="text-accent-warning border-accent-warning/20 hover:bg-accent-warning/10" data-id="element-1031">
              View All
            </Button>
          </div>
          <div className="space-y-3" data-id="element-1032">
            {[{
            name: 'Milan S.',
            status: 'Was weekly → 35 days'
          }, {
            name: 'Jelena K.',
            status: 'Was weekly → 42 days'
          }].map((customer, i) => <div key={i} className="flex items-center justify-between p-3 bg-white/5 rounded-lg" data-id="element-1033">
                <span className="font-medium" data-id="element-1034">{customer.name}</span>
                <span className="text-sm text-accent-warning" data-id="element-1035">
                  {customer.status}
                </span>
              </div>)}
            <div className="text-center text-sm text-text-secondary pt-2" data-id="element-1036">
              23 customers at risk
            </div>
          </div>
        </Card>
      </div>
    </div>;
}